import { colors } from 'components/styles/variables';

interface SectionHeaderProps {
  children: string;
  id?: string;
  labelClassName?: string;
  sectionClassName?: string;
}

function Bar(): JSX.Element {
  return (
    <div className="bar-container">
      <div className="bar-line" />
      <style jsx>{`
        .bar-container {
          flex-grow: 1;
          display: flex;
          justify-content: center;
          flex-direction: column;
        }

        .bar-line {
          height: 2px;
          background-color: ${colors.G1};
        }
      `}</style>
    </div>
  );
}

interface SectionHeaderProps {
  children: string;
  id?: string;
  labelClassName?: string;
  sectionClassName?: string;
}

function SectionHeader({
  children,
  id,
  labelClassName = '',
  sectionClassName = '',
}: SectionHeaderProps): JSX.Element {
  return (
    <div className={`section-header-container ${sectionClassName}`} id={id}>
      <Bar />
      <div className={`label ${labelClassName}`}>{children}</div>
      <Bar />
      <style jsx>{`
        .section-header-container {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          justify-content: space-between;
        }

        .label {
          text-transform: uppercase;
          font-weight: 900;
          font-size: 18px;
          letter-spacing: 0.2px;
          margin: 0 15px;
        }
      `}</style>
    </div>
  );
}

export default SectionHeader;
